import React from 'react'
import Container from 'react-bootstrap/Container';
import Table from 'react-bootstrap/Table';
import Tooltip from 'react-bootstrap/Tooltip';
import { Button, OverlayTrigger } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import { FaEdit } from "react-icons/fa";

const TableHeader = (props) => {
  return (

    <thead>
      <tr>
        <th style={{width:'10%'}}>Quote Number</th>
        <th style={{width:'15%'}}>Job Title</th>
        <th className='d-none d-sm-table-cell' style={{width:'20%'}}>Job Description</th>
        <th className='d-none d-sm-table-cell' style={{width:'10%'}}>Created By</th>
        <th className='d-none d-sm-table-cell' style={{width:'10%'}}>Due Date</th>
        <th style={{width:'5%'}}>{props.mode==0?'Edit':''}</th>
      </tr>
    </thead>
  )
}

const TableBody = (props) => {
  if (props.fastquotingdoorsObj) {
    const rows = props.fastquotingdoorsObj.map((row, index) => { 
      return (      
        <tr key={index}>       
          <td>      
            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderEditTooltip}>
              <Link
                fastquotingdoornumber = {row.fastquotingdoornumber}
                to={`/view-door-fast-quote-versions/${row.id}`}
              >              
                {row.fastquotingdoornumber}
              </Link>  
            </OverlayTrigger>         
          </td>
          <td>  
            {row.job.jobtitle}
          </td>
          <td className='d-none d-sm-table-cell'>  
            {row.job.jobdescription}
          </td>        
          <td className='d-none d-sm-table-cell'>  
            {row.user.userlastname + ", " + row.user.userfirstname}
          </td>   
          <td className='d-none d-sm-table-cell'>  
            {new Date(row.createdAt).toUTCString().substring(0,16)}
          </td>  

          <td align='center'>  
            {(props.mode==0) &&
              <Button><Link to = {`/view-door-fast-quote-versions/${row.id}`}><FaEdit color='white'/></Link></Button>          
            }
            {(props.mode==1) &&
              <Button onClick={() => {
                console.log(row);
                props.onSelected(row.id,row.jobtitle,row.jobdescription,row.client.id,row.client.clientname);
                props.handleClose();
              }} variant='link' value={row.id}>Select</Button>
            } 
          </td>            
        </tr>
      )
    })
    return (
      <tbody>
        {rows}
      </tbody>
    )  
  }
  else {
    return null;
  }
}

const renderEditTooltip = (props) => (
  <Tooltip id="button-tooltip" {...props}>
    Click to view and create quote versions.
  </Tooltip>
);



const FastQuotingDoorsList = (props) => {        
  
  return (
    <>
    <Container>
      <Row>
        <Table style={{verticalAlign:"baseline", marginLeft:"13px",width:"99%"}} striped bordered hover size="sm">
          <TableHeader mode={props.mode} />
          <TableBody 
            handleClose={props.handleClose} 
            onSelected={props.onSelected} 
            mode={props.mode} 
            fastquotingdoorsObj={props.listOfFastQuotingDoors} 
          />
        </Table>
      </Row>
      <hr/>
    </Container>
    </>
    );
}

export default FastQuotingDoorsList;